import { IOneTimeReminder } from "./types"
import React, { useState } from "react"
import { useTranslations } from "@cirrus/core/i18n/provider"
import { StyledClosedText, StyledReminderText, StyledTitle, StyledTitleText, StyledWrapper } from "./styles"
import { MuiIcon } from "../MuiIcon"
import { checkWasReminderOpened, setReminderClosed } from "./helpers"

export const ReminderComponent = (props: IOneTimeReminder) => {
  const [isOpen, setOpen] = useState<boolean>(!checkWasReminderOpened(props.reminderId))
  const { i18n } = useTranslations()
  
  if (!isOpen) return <></>
  
  const closeHandler = () => setOpen(() => {
    setReminderClosed(props.reminderId)
    
    return false
  })
  
  return (
    <StyledWrapper>
      <StyledTitle>
        <StyledTitleText>
          <MuiIcon.InfoOutlined />
          {i18n("General:Reminder")}
        </StyledTitleText>
        <StyledClosedText onClick={closeHandler}>
          {i18n("General:CloseReminder")}
        </StyledClosedText>
      </StyledTitle>
      <StyledReminderText>
        {props.reminderText}
      </StyledReminderText>
    </StyledWrapper>
  )
}